export type FilterType = 'normal' | 'grayscale' | 'sepia' | 'vintage' | 'cool' | 'warm';
export type TemplateType = 'custom' | 'strava-classic' | 'strava-minimal' | 'strava-hero' | 'strava-collage' | 'strava-achievement';
export type MapStyleType = 'roadmap' | 'satellite' | 'terrain' | 'hybrid';
export type LineWidthType = 'thin' | 'normal' | 'thick' | 'extra-thick';
export type MarkerStyleType = 'default' | 'custom' | 'minimal' | 'none';
export type MapPresetType = 'none' | 'noturno' | 'neon' | 'retro' | 'minimalista';

export interface StoryConfig {
  metricsPosition: 'top' | 'center' | 'bottom' | 'top-right' | 'top-left';
  boxStyle: 'minimal' | 'bold' | 'glass' | 'strava';
  boxOpacity: number; // 0-100%
  includeMap: boolean;
  mapPosition: 'top' | 'center' | 'corner';
  mapSize: number; // 0-100%
  mapStyle?: MapStyleType;
  lineWidth?: LineWidthType;
  mapZoom?: number; // 10-21 (Google Maps zoom level)
  showStartMarker?: boolean;
  showEndMarker?: boolean;
  markerStyle?: MarkerStyleType;
  showWaypoints?: boolean; // Mostrar pontos importantes (10%, 25%, 50%, 75%, 90%)
  filter?: FilterType;
  customText?: string;
  emoji?: string;
  logoPosition?: 'top' | 'bottom' | 'corner';
}

export interface StoryTemplate {
  id: TemplateType;
  name: string;
  description: string;
  icon: string;
  config: StoryConfig;
  motivationalTexts: string[];
  gradient?: string;
}

export interface StorySlide {
  id: string;
  type: 'map' | 'selfie' | 'custom';
  imageUrl: string;
  config?: StoryConfig;
}

export const DEFAULT_STORY_CONFIG: StoryConfig = {
  metricsPosition: 'bottom',
  boxStyle: 'glass',
  boxOpacity: 70,
  includeMap: true,
  mapPosition: 'corner',
  mapSize: 40,
  mapZoom: 15, // Zoom padrão
  showStartMarker: true,
  showEndMarker: true,
  markerStyle: 'default',
  showWaypoints: false,
  filter: 'normal',
  customText: '',
  emoji: undefined,
  logoPosition: 'bottom',
};
